var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-entity',[_c('Terrain'),_vm._v(" "),_c('a-entity',{ref:"env",attrs:{"position":"0 -.7 0","environment":"preset: egypt; fog: .8; dressing: none; skyColor: white; horizonColor: grey; ground: hills; groundTexture: none; groundColor: grey"},on:{"loaded":_vm.envLoaded}}),_vm._v(" "),_c('Clouds')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c67154b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/environment/Environment.vue
// module id = null
// module chunks = 